<template>
  <span class="MaterialNum">
    <el-dialog title="选择产品代码对应的物料号" :visible.sync="dialogTableVisible" :close-on-click-modal="false" :close-on-press-escape="false" top="20px" width="99%" lock-scroll>
      <div class="block" style="text-align: right;margin-bottom: 10px;">
        <el-button @click="dialogTableVisible=false">取 消</el-button>
        <el-button type="primary" @click="submit">确 定</el-button>
      </div>
      <div v-loading="loading">
        <div class="wlhd el-table el-table--border el-table--fit el-table--small el-table--striped el-table--enable-row-transition">
          <div class="el-table__body-wrapper">
            <table ref="header" cellspacing="0" cellpadding="0" border="0" class="el-table__body" style="width: 100%;">
              <colgroup>
                <col width="6">
                <col width="11">
                <col width="6">
                <col width="10">
                <col width="5">
                <col width="16">
                <col width="5">
                <col width="5">
                <col width="5">
                <col width="5">
                <col width="5">
                <col width="5">
                <col width="5">
                <col width="5">
                <col width="5">
                <col width="7">
              </colgroup>
              <thead>
                <tr>
                  <th class=" is-center"><div class="cell text-align-left">销售产品代码</div></th>
                  <th class=" is-center"><div class="cell text-align-left">产品型号</div></th>
                  <th class=" is-center"><div class="cell text-align-left">电源线规格</div></th>
                  <th class=" is-center"><div class="cell text-align-left">物料号</div></th>
                  <th class=" is-center"><div class="cell text-align-left">是否主料号</div></th>
                  <th class=" is-center"><div class="cell text-align-left">物料描述</div></th>
                  <th class=" is-center"><div class="cell text-align-left">市场代码名称</div></th>
                  <th class=" is-center"><div class="cell text-align-left">备货模式</div></th>
                  <th class=" is-center"><div class="cell text-align-left">海外生产模式</div></th>
                  <th class=" is-center"><div class="cell text-align-left">产品数量</div></th>
                  <th class=" is-center"><div class="cell text-align-left">库存</div></th>
                  <th class=" is-center"><div class="cell text-align-left">累扣量</div></th>
                  <th class=" is-center"><div class="cell text-align-left">产品状态</div></th>
                  <th class=" is-center"><div class="cell text-align-left">物料分类</div></th>
                  <th class=" is-center"><div class="cell text-align-left">选择标准</div></th>
                  <th class=" is-center"><div class="cell text-align-left">备注</div></th>
                </tr>
              </thead>
            </table>
          </div>
          <div class="ht el-table el-table--border el-table--fit el-table--small el-table--striped el-table--enable-row-transition">
            <div class="el-table__body-wrapper" style="height: 700px;">
              <el-scrollbar>
                <table ref="body" cellspacing="0" cellpadding="0" border="0" class="el-table__body" style="width: 100%;">
                  <colgroup>
                    <col width="6">
                    <col width="11">
                    <col width="6">
                    <col width="10">
                    <col width="5">
                    <col width="16">
                    <col width="5">
                    <col width="5">
                    <col width="5">
                    <col width="5">
                    <col width="5">
                    <col width="5">
                    <col width="5">
                    <col width="5">
                    <col width="5">
                    <col width="7">
                  </colgroup>
                  <template v-for="(row,index) in list">
                    <Row :key="index" :row="row" :defvalue="MaterialNumValues[row.productSalesCode]" />
                  </template>
                </table>
              </el-scrollbar>
            </div>
          </div>
        </div>
        <div class="block" style="text-align: right;padding-top: 20px">
          <el-button @click="dialogTableVisible=false">取 消</el-button>
          <el-button type="primary" @click="submit">确 定</el-button>
        </div>
      </div>
    </el-dialog>
  </span>
</template>
<script type="es6">
import { getMaterialInfo } from '@/API';
import Row from './MaterialRow';
let RowIndex;
export default {
  data () {
    return {
      loading: false,
      page: {
        currentPage: 1,
        pagesize: 4,
        total: 0
      },
      list: [],
      dialogTableVisible: false,
      MaterialNumValues: {}
    };
  },
  components: {
    Row
  },
  computed: {
    proList () {
      let ids = [];
      this.tableData.forEach((item, index) => {
        ids.push({ proCode: item.productCode, amount: item.productAmount });
      });
      return ids;
    }
  },
  methods: {
    showdialog (opt, index, MaterialNumValues) {
      RowIndex = index;
      this.MaterialNumValues = MaterialNumValues;
      if (index === undefined) {
        RowIndex = 'all';
      }
      this.dialogTableVisible = true;
      this.list = [];
      this.searchData(opt);
    },
    // 初始化自动设置料号
    initReturnLiaohao (opt, MaterialNumValues) {
      this.MaterialNumValues = MaterialNumValues;
      this.list = [];
      getMaterialInfo(opt).then((res) => {
        let json = res.data;
        if (json.status === '200') {
          this.list = json.data;
          // 过滤是否都选择了料号
          this.list.forEach((row) => {
            if (row.materialGroup.length === 1) {
              this.$set(row, 'selected', row.materialGroup[0].materialCode);
              this.$set(row, 'materialUnit', row.materialGroup[0].materialUnit);
            }
            row.materialGroup.forEach((item) => {
              if (!row.markCodes) {
                this.$set(row, 'markCodes', []);
              }
              if (item.marketCode && row.markCodes.indexOf(item.marketCode) < 0) {
                row.markCodes.push(item.marketCode);
              }
              if (item.isChecked) {
                this.$set(row, 'selected', item.materialCode);
                this.$set(row, 'materialUnit', item.materialUnit);
              }
            });
          });
          const _list = this.list.filter((item) => item.selected);
          this.$emit('chooseMateriaNew', { list: _list });
        }
      });
    },
    searchData (opt) {
      this.loading = true;
      this.list = [];
      getMaterialInfo(opt).then((res) => {
        this.loading = false;
        let json = res.data;
        if (json.status === '200') {
          this.list = json.data;
        }
      }).catch(() => {
        this.loading = false;
      });
    },
    submit () {
      // 判断是否都选择了料号
      let error = '';
      this.list.forEach((item) => {
        if (!error && !item.selected) {
          error += '【' + item.productSalesCode + '】';
        }
      });
      if (error) {
        this.$notify.error({
          message: error + '存在产品未选择料号！'
        });
        return;
      };
      this.$emit('chooseMateria', { list: this.list, RowIndex });
      this.dialogTableVisible = false;
    }
  },
  mounted () {
  }
};
</script>
<style lang="scss">
  .MaterialNum{
    .el-dialog__body{
      padding: 20px!important;
    }
    .wlhd.el-table--small th {
      padding: 1px 0;
    }
    .ht.el-table{
      border-top: none;
    }
    .el-table--border th, .el-table--border td {
      border-right: 1px solid #000000;
    }
    .el-table th.is-leaf, .el-table td {
      border-bottom: 1px solid #000000;
    }
  }

</style>
